if (!customElements.get('sidiz-image-viewer')) {
  customElements.define('sidiz-image-viewer', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.trigger = this.querySelector('.sidiz-image-viewer__trigger');
      this.dialog = this.querySelector('dialog');
      this.viewport = this.querySelector('.sidiz-image-viewer__viewport');
      this.image = this.querySelector('.sidiz-image-viewer__image');
      this.error = this.querySelector('.sidiz-image-viewer__error');
      this.scale = 1;
      this.trigger.addEventListener('click', () => this.open(), options);
      this.querySelector('[data-image-close]').addEventListener('click', () => this.dialog.close(), options);
      this.querySelectorAll('[data-image-zoom]').forEach(button => {
        button.addEventListener('click', () => this.resize(this.scale + Number(button.dataset.imageZoom)), options);
      });
      this.dialog.addEventListener('close', () => this.restore(), options);
      window.addEventListener('resize', () => {
        if (this.dialog.open && this.image.naturalWidth) this.resize(this.scale);
      }, options);
    }

    async open() {
      const source = Array.from(this.trigger.querySelectorAll('img')).find(image => image.getBoundingClientRect().width > 0);
      if (!source || this.dialog.open) return;
      this.savedOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.dialog.showModal();
      this.error.hidden = true;
      this.image.hidden = true;
      this.image.alt = source.alt;
      this.image.loading = 'eager';
      // Use the full image URL, not the small responsive thumbnail selected by the browser.
      this.image.src = source.src;
      try {
        await this.image.decode();
        if (!this.dialog.open) return;
        this.image.hidden = false;
        this.scale = 1;
        this.resize(1);
        this.viewport.scrollTo(0, 0);
      } catch {
        this.error.hidden = false;
      }
    }

    resize(nextScale) {
      if (!this.image.naturalWidth) return;
      const previousWidth = this.image.getBoundingClientRect().width || 1;
      const centreX = (this.viewport.scrollLeft + this.viewport.clientWidth / 2) / previousWidth;
      const centreY = (this.viewport.scrollTop + this.viewport.clientHeight / 2) / previousWidth;
      this.scale = Math.max(1, Math.min(4, nextScale));
      const ratio = this.image.naturalWidth / this.image.naturalHeight;
      const fittedWidth = Math.min(this.image.naturalWidth, this.viewport.clientWidth - 32, (this.viewport.clientHeight - 32) * ratio);
      const width = Math.max(1, fittedWidth) * this.scale;
      this.image.style.width = `${width}px`;
      this.querySelector('.sidiz-image-viewer__scale').value = `${Math.round(this.scale * 100)}%`;
      this.querySelector('[data-image-zoom="-0.5"]').disabled = this.scale <= 1;
      this.querySelector('[data-image-zoom="0.5"]').disabled = this.scale >= 4;
      this.viewport.scrollLeft = centreX * width - this.viewport.clientWidth / 2;
      this.viewport.scrollTop = centreY * width - this.viewport.clientHeight / 2;
    }

    restore() {
      if (this.savedOverflow !== undefined) {
        document.body.style.overflow = this.savedOverflow;
        this.savedOverflow = undefined;
      }
      if (this.isConnected) this.trigger.focus({ preventScroll: true });
    }

    disconnectedCallback() {
      this.restore();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
